<div *ngIf="left !==0 && top !== 0" class="container" [style.left]="left + 'px'" [style.top]="top + 'px'" [ngClass]="position">
  <p>{{text}}</p>
</div>
<div *ngIf="isVisible && left === 0 && top ===0" class="container" [ngClass]="position" style="position: absolute;
  top: -8px;
  left: 20px;">
  <p>{{text}}</p>
</div>
